{
  "close": "Kapat"
}
